module.exports = __webpack_public_path__ + "media/images/cursors/arrow_right@2x-ef576b05446aa17c608b37a610aa6036.png";